"use strict";

var _classCallCheck = require("E:\\MyProject\\Project\\furegame\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("E:\\MyProject\\Project\\furegame\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("E:\\MyProject\\Project\\furegame\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _assertThisInitialized = require("E:\\MyProject\\Project\\furegame\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/assertThisInitialized");

var _inherits = require("E:\\MyProject\\Project\\furegame\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MainCore = void 0;

var _rxjs = require("rxjs");

var _Core = require("../Core");

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
} // only used as type for `main` module.


var MainCore =
/*#__PURE__*/
function (_Core$Core) {
  _inherits(MainCore, _Core$Core);

  function MainCore(emitter, events, subject) {
    var _this;

    _classCallCheck(this, MainCore);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(MainCore).call(this, 'main', events, subject));

    _defineProperty(_assertThisInitialized(_this), "emitter", void 0);

    _this.emitter = emitter;
    return _this;
  }

  return MainCore;
}(_Core.Core);

exports.MainCore = MainCore;
var main = new MainCore(
/* stub! */
undefined, {
  emit: function emit() {
    /* stub! */
  },
  // eslint-disable-line @typescript-eslint/no-unused-vars
  fullscreen: function fullscreen() {
    /* stub! */
  }
}, new _rxjs.Subject());
var _default = main;
exports.default = _default;

if (typeof window !== 'undefined') {
  // eslint-disable-next-line no-undef
  window.addEventListener('load', function () {
    var _main$events;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return (_main$events = main.events).emit.apply(_main$events, ['load'].concat(args));
  });
}